import React, { useState } from 'react';
import { Col, Row, OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { setHasImportantUnsavedChanges } from '@rd-web-markets/shared/dist/store/features/unsavedChangesSlice';
import ReportNotesForm from './ProjectNotesForm';
export default function ProjectComments(_ref) {
  let {
    report,
    setReport,
    reportNotesHandlers
  } = _ref;
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const {
    notes,
    setNotes,
    createNote,
    loading
  } = reportNotesHandlers;
  const handleCreateNote = async formData => {
    try {
      const response = await createNote(formData);
      const updatedNotes = [response, ...notes];
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
      setShowCommentPopup(true);
      dispatch(setHasImportantUnsavedChanges(false));
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const popover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-basic"
  }, /*#__PURE__*/React.createElement(Popover.Body, null, t('comment_saved_to_comments_tab'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
    to: `${location.pathname}?key=notes`
  }, t('link_to_comment'))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-primary",
    onClick: () => setShowCommentPopup(false)
  }, t('close')))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "right",
    show: showCommentPopup,
    rootClose: true,
    overlay: popover
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReportNotesForm, {
    loading: loading,
    onSubmit: handleCreateNote,
    noteType: "summary",
    isImmutableUnderReview: true
  }))))));
}